// extracted by mini-css-extract-plugin
export var container = "_30-0";
export var error = "_30-9";
export var label = "_30-5";
export var light = "_30-6";
export var md = "_30-3";
export var sm = "_30-2";
export var thin = "_30-8";
export var thinBold = "_30-7";
export var vertical = "_30-4";
export var xs = "_30-1";